import { FlexBox } from '@dixa/lib-shared-habla';

import { KnowledgeBaseView } from './components/knowledgeBase';
import { SettingsChatbotsMimView } from './components/mim';

export const MimWrapper = (): JSX.Element => {
  return (
    <FlexBox
      flexDirection="column"
      style={{ height: '100%', minHeight: '100%' }}
    >
      <SettingsChatbotsMimView />
      <KnowledgeBaseView />
    </FlexBox>
  );
};
